import React from 'react';
import { motion } from 'framer-motion';
export function StepsSection() {
  const steps = [{
    num: '1',
    title: 'Escríbenos por WhatsApp',
    desc: 'ahora mismo'
  }, {
    num: '2',
    title: 'Te asignamos tu clase gratis',
    desc: 'en el horario que te convenga'
  }, {
    num: '3',
    title: 'Vienes, entrenas, y descubres',
    desc: 'por qué San Miguel está eligiendo este lugar'
  }];
  return <section className="py-24 bg-gym-charcoal" data-id="element-285">
      <div className="max-w-5xl mx-auto px-4" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-287">
          <h2 className="text-3xl md:text-5xl font-bold uppercase tracking-wide text-white" data-id="element-288">
            Así de fácil es <span className="text-gym-green" data-id="element-289">empezar</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-290">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gym-charcoalLight -z-0" data-id="element-291"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-292">
              <div className="w-24 h-24 bg-gym-dark rounded-full border-4 border-gym-green flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(16,185,129,0.2)]" data-id="element-293">
                <span className="text-4xl font-heading font-bold text-white" data-id="element-294">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2 uppercase tracking-wider" data-id="element-295">
                {step.title}
              </h3>
              <p className="text-gray-400 text-lg" data-id="element-296">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}